
import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { BarChart3, PieChartIcon } from "lucide-react";
import PieChartDisplay from "../charts/PieChartDisplay";
import BarChartDisplay from "../charts/BarChartDisplay";

interface KleurenTabProps {
  colorsData: any[];
  kleurBeschikbaarheid: any[];
}

const KleurenTab: React.FC<KleurenTabProps> = ({
  colorsData,
  kleurBeschikbaarheid
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Meest voorkomende kleuren</CardTitle>
            <CardDescription>Aantal keer besteld per kleur</CardDescription>
          </div>
          <BarChart3 className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <BarChartDisplay
            data={colorsData}
            dataKey="value"
            barName="Aantal bestellingen"
          />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Kleur beschikbaarheid</CardTitle>
            <CardDescription>Status van kleur aanvragen</CardDescription>
          </div>
          <PieChartIcon className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <PieChartDisplay data={kleurBeschikbaarheid} />
        </CardContent>
      </Card>
    </div>
  );
};

export default KleurenTab;
